// extracted by mini-css-extract-plugin
export default {"holder_banner_ads":"ads_holder_banner_ads__xUXqs"};